import { toTitleCase } from '../../../Utility/toTitleCase';
import { formatPhone, formatPhoneLink } from '../../../Utility/phoneNumberFormat';
import { useEffect, useState } from 'react';
// import CustomerQuestionsModal from './CustomerQuestionsModal';
import { usdFormat } from '../../../Utility/usdFormat';
import { Customer } from '../../../Types/Customer';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';
import { ArrowDropDown, ArrowDropUp, Edit } from '@mui/icons-material';
import { makeCall } from '../../../Utility/makeCallText';

const CustomerDetails = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const item = location.state?.item as Customer
    const bids = item.last5Bids
    const id = item.id;
    const [questionModal, setQuestionModal] = useState(false);

    const images = [
        {
            img: 'https://mockmind-api.uifaces.co/content/human/221.jpg'
        },
        {
            img: 'https://mockmind-api.uifaces.co/content/human/211.jpg'
        }
    ];
    
    return (
        <Container>
            <div 
                style={{
                    position: 'sticky',
                    top: 60,
                    zIndex: 1000,
                    paddingBlock: '10px',
                    display: 'flex'
                }}
                className='bg-light'
            >
                <div style={{ flex: 1, textAlign: 'start' }}>
                    <Button
                        className='mainButton'
                        onClick={() => navigate('CRMActions', { state: item })}
                        >
                        <span className='itemName fw-bold'>CRM</span>
                    </Button>
                </div>
                <div style={{ flex: 1, textAlign: 'end' }}>
                    {/* <Button 
                        className='mainButton'
                        onPress={() => setQuestionModal(true)}
                        >
                        <Edit />
                        <span className='itemName fw-bold'>Profile</span>
                    </Button> */}
                </div>
            </div>
            <Row>
                <Col md={6} xs={12}>
                    <Card 
                        className='shadow my-2'
                        style={{ minHeight: 250 }}
                    >
                        <CardHeader style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around'}}>
                            <span style={{ display: 'inline' }} className='headerText'>Sales</span>
                            <span style={{ display: 'inline' }} className='headerText'>Sales CY</span>
                            <span style={{ display: 'inline' }} className='headerText'>Sales LY</span>
                        </CardHeader>
                        <CardBody 
                            style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around'}}
                        >
                            <div>
                                <span className='headerText d-block'>MTD</span>
                                <span className='headerText d-block'>YTD</span>
                            </div>
                            <div>
                                <div>
                                    {Number(item.mtdSLS) > Number(item.mtdLAYR)
                                    ? <ArrowDropUp sx={{ color: 'limegreen'}} />
                                    : <ArrowDropDown sx={{ color: 'red'}} /> }
                                </div>
                                <div>
                                    {Number(item.ytdSLS) > Number(item.ytdLAYR)
                                    ? <ArrowDropUp sx={{ color: 'limegreen'}} />
                                    : <ArrowDropDown sx={{ color: 'red'}} /> }
                                </div>
                            </div>
                            <div>
                                <div className='salesTabletOrange px-2'>
                                    <span className='tabletText'>{usdFormat.format(item.mtdSLS)}</span>
                                </div>
                                <div className='salesTabletOrange px-2'>
                                    <span className='tabletText'>{usdFormat.format(item.ytdSLS)}</span>
                                </div>
                            </div>
                            <div>
                                <div className='salesTabletGrey px-2'>
                                    <span className='tabletText'>{usdFormat.format(item.mtdLAYR)}</span>
                                </div>
                                <div className='salesTabletGrey px-2'>
                                    <span className='tabletText'>{usdFormat.format(item.ytdLAYR)}</span>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
                <Col md={6} xs={12}>
                    <Card 
                        className='shadow my-2'
                        style={{ minHeight: 250 }}
                    >
                        <CardHeader>
                            <span className='headerText'>Contact</span>
                        </CardHeader>
                        <CardBody style={{ display: 'flex', gap: 10 }}>
                            <div style={{ textAlign: 'left', display: 'flex', flexDirection: 'column' }}>
                                <span className='itemName'>Cust ID:</span>
                                <span className='itemName'>Cust Name:</span>
                                <span className='itemName'>Contact Name:</span>
                                <span className='itemName'>Phone:</span>
                                <span className='itemName'>Add 1:</span>
                                {item.address2 && <span className='itemName'>Add 2:</span>}
                                {item.address3 && <span className='itemName'>Add 3:</span>}
                                {item.address4 && <span className='itemName'>Add 4:</span>}
                                {item.language && <span className='itemName'>Language:</span>}
                            </div>
                            <div style={{ textAlign: 'left', display: 'flex', flexDirection: 'column' }}>
                                <span className='itemDescription'>{item.id}</span>
                                <span className='itemDescription'>{toTitleCase(item.name)}</span>
                                <span className='itemDescription'>{toTitleCase(item.contact)}</span>
                                <a 
                                    onClick={() => makeCall(formatPhoneLink(item.phone))}
                                    style={{ color: '#1a73e8', textDecoration: 'underline', cursor: 'pointer' }}
                                >
                                    {formatPhone(item.phone)}
                                </a>
                                <span className='itemDescription'>{toTitleCase(item.address1)}</span>
                                {item.address2 && <span className='itemDescription'>{toTitleCase(item.address2)}</span>}
                                {item.address3 && <span className='itemDescription'>{toTitleCase(item.address3)}</span>}
                                {item.address4 && <span className='itemDescription'>{toTitleCase(item.address4)}</span>}
                                {item.language && <span className='itemDescription'>{toTitleCase(item.language)}</span>}
                            </div>
                        </CardBody>
                    </Card>
                </Col>
                <Col md={6} xs={12}>
                    <Card 
                        className='shadow my-2'
                        style={{ minHeight: 250 }}
                    >
                        <CardHeader>
                            <span className='headerText'>Accounting</span>
                        </CardHeader>
                        <CardBody style={{ display: 'flex', gap: 10 }}>
                            <div style={{ textAlign: 'left', display: 'flex', flexDirection: 'column' }}>
                                <span className='itemName'>A/R Balance:</span>
                                <span className='itemName'>Last Payment:</span>
                                <span className='itemName'>Credit Limit:</span>
                                <span className='itemName'>Credit Code:</span>
                                <span className='itemName'>Class:</span>
                                <span className='itemName'>Tax Rate:</span>
                                <span className='itemName'>Type:</span>
                            </div>
                            <div style={{ textAlign: 'left', display: 'flex', flexDirection: 'column' }}>
                                <span className='itemDescription'>{usdFormat.format(item.arBAL) ?? 'None'}</span>
                                <span className='itemDescription'>{item.laPMT ?? 'None'}</span>
                                <span className='itemDescription'>{usdFormat.format(item.crLIM) ?? 'None'}</span>
                                <span className='itemDescription'>{item.crCDE ?? 'None'}</span>
                                <span className='itemDescription'>{item.class ?? 'None'}</span>
                                <span className='itemDescription'>{item.taxRate ?? 'None'}</span>
                                <span className='itemDescription'>{item.type ?? 'None'}</span>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
                <Col md={6} xs={12}>
                    <Card 
                        className='shadow my-2'
                        style={{ minHeight: 250 }}
                    >
                        <CardHeader>
                            <span className='headerText'>Recent Bids</span>
                        </CardHeader>
                        <CardBody>
                            <div>
                                {!bids.length && <span className='itemDescription'>No recent bids</span>}
                                {bids.map((bid) => (
                                    <div key={bid} style={{ display: 'flex', gap: 10 }}>
                                        <div>
                                            <span className='itemName'>Bid #:</span>
                                        </div>
                                        <div>
                                            <span className='itemDescription'>{bid}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </CardBody>
                    </Card>
                </Col>
                {/* <div style={[styles.container, { paddingHorizontal: 16 }]}>
                    <span style={styles.headerText}>Key Personnel</span>
                    <Divider />
                    <div style={{ marginTop: 10 }}>
                        <TouchableOpacity
                            style={styles.itemContainer}
                            onPress={() => navigation.navigate('BuyerProfile')}
                        >
                            <div>
                                <Avatar 
                                    size={64}
                                    title='TB'
                                    source={{ uri: 'https://mockmind-api.uifaces.co/content/human/221.jpg'}}
                                    rounded
                                    containerStyle={{ backgroundColor: 'coral' }}
                                />
                            </div>
                            <div style={{ marginLeft: 20 }}>
                                <span style={{ fontWeight: 'bold'}}>Tina Belcher</span>
                                <span style={styles.titleText}>Shop Assistant</span>
                            </div>
                        </TouchableOpacity>
                        <TouchableOpacity style={styles.itemContainer}>
                            <div>
                                <Avatar
                                    size={64}
                                    title='RB'
                                    source={{ uri: 'https://mockmind-api.uifaces.co/content/human/211.jpg'}}
                                    rounded
                                    containerStyle={{ backgroundColor: '#3d4db7' }}
                                />
                            </div>
                            <div style={{ marginLeft: 20 }}>
                                <span style={{ fontWeight: 'bold'}}>Ron Burgundy</span>
                                <span style={styles.titleText}>Assistant Manager</span>
                            </div>
                        </TouchableOpacity>
                    </div>
                </div> */}
            </Row>
            {/* <CustomerQuestionsModal 
                visible={questionModal}
                onClose={() => setQuestionModal(false)}
            />  */}
        </Container>
    )
};

export default CustomerDetails;